import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import { Provider } from "react-redux";
import './i18n';
import App from './App';
import "./assets/base.scss";
import reportWebVitals from './reportWebVitals';
import store from './store/ReduxStore.js';
import { SensitiveInfoProvider } from './context/SensitiveInfoContext';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <SensitiveInfoProvider>
        <App />
      </SensitiveInfoProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
